import React from 'react'
import './selectOutlet.style.scss'
import classNames from 'classnames'

interface ISelectOutletProps extends React.HTMLProps<HTMLSelectElement> {
    label: string
    required?: boolean
    errors?: string
    name: string
    touched?: boolean
    options: Array<ISelectOption>
    firstOption?: string
}

const SelectOutlet = ({
    label,
    required = false,
    errors,
    touched,
    name,
    disabled,
    firstOption,
    options,
    ...props
}: ISelectOutletProps) => {
    return (
        <div className="floating-label-select">
            <select
                id={name}
                name={name}
                data-value={props.value}
                {...props}
                disabled={disabled}
                value={props.value}
                className={classNames(
                    (touched && errors ? 'invalid ' : '') +
                        (touched && !errors ? 'valid ' : ''),
                    'px-11'
                )}
            >
                <option>{firstOption ? firstOption : ''}</option>
                {React.Children.toArray(
                    options?.map((item, index) => (
                        <>
                            <option key={index} value={item.value}>
                                {item.label}
                            </option>
                        </>
                    ))
                )}
            </select>
            <label htmlFor={name}>
                {label} {required && <span className="color-red-3">*</span>}
            </label>
            {touched && errors && (
                <>
                    <div className="pt-1">
                        <small>
                            <i className="icon-warning"></i> {errors}
                        </small>
                    </div>
                </>
            )}
        </div>
    )
}

export default SelectOutlet
